import React, { useCallback, useEffect, useState, Component } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
// Import slides
import { Slide1_Category } from '../components/slides/Slide1_Category';
import { Slide2_Problem } from '../components/slides/Slide2_Problem';
import { Slide3_System } from '../components/slides/Slide3_System';
import { Slide4_SystemVisual } from '../components/slides/Slide4_SystemVisual';
import { Slide5_Proof } from '../components/slides/Slide5_Proof';
import { Slide6_WhatWeDo } from '../components/slides/Slide6_WhatWeDo';
import { Slide7_Tiers } from '../components/slides/Slide7_Tiers';
import { Slide8_Investment } from '../components/slides/Slide8_Investment';
const SLIDES = [Slide1_Category, Slide2_Problem, Slide3_System, Slide4_SystemVisual, Slide5_Proof, Slide6_WhatWeDo, Slide7_Tiers, Slide8_Investment];
export function PitchDeck() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = useCallback(() => {
    setCurrentSlide(prev => (prev + 1) % SLIDES.length);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentSlide(prev => (prev - 1 + SLIDES.length) % SLIDES.length);
  }, []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'Space') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide]);
  const CurrentSlideComponent = SLIDES[currentSlide];
  return <div className="h-screen w-full bg-[#0B1120] text-slate-200 overflow-hidden relative selection:bg-emerald-500/30" data-id="element-539">
      {/* Main Content Area */}
      <div className="h-full w-full relative pb-20 sm:pb-24" data-id="element-540">
        <AnimatePresence mode="wait" data-id="element-541">
          <CurrentSlideComponent key={currentSlide} data-id="element-542" />
        </AnimatePresence>
      </div>

      {/* Navigation Controls (Bottom) - Mobile Optimized */}
      <div className="absolute bottom-0 left-0 w-full p-3 sm:p-6 flex items-center justify-between z-50 pointer-events-none" data-id="element-543">
        <div className="flex items-center space-x-2 sm:space-x-4 pointer-events-auto" data-id="element-544">
          <a href="https://thehireadvantage.co" target="_blank" rel="noopener noreferrer" className="hover:opacity-100 transition-opacity" data-id="element-545">
            <img src="https://cdn.magicpatterns.com/uploads/da1XxGaozgRpThQTwPCSSQ/yellow_full_logo.png" alt="HIRE" className="h-6 sm:h-8 hover:opacity-90 transition-opacity" data-id="element-546" />
          </a>
        </div>

        <div className="flex items-center space-x-1 sm:space-x-2 pointer-events-auto" data-id="element-547">
          <button onClick={prevSlide} className="p-2 sm:p-2 rounded-full hover:bg-slate-800 text-slate-500 hover:text-white transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Previous slide" data-id="element-548">
            <ChevronLeft size={20} data-id="element-549" />
          </button>

          <div className="flex space-x-1 sm:space-x-1.5 mx-1 sm:mx-2" data-id="element-550">
            {SLIDES.map((_, idx) => <button key={idx} onClick={() => setCurrentSlide(idx)} className={`h-1.5 sm:h-1.5 rounded-full transition-all duration-300 ${idx === currentSlide ? 'w-6 sm:w-8 bg-emerald-500' : 'w-1.5 bg-slate-800 hover:bg-slate-700'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-551" />)}
          </div>

          <button onClick={nextSlide} className="p-2 sm:p-2 rounded-full hover:bg-slate-800 text-slate-500 hover:text-white transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Next slide" data-id="element-552">
            <ChevronRight size={20} data-id="element-553" />
          </button>
        </div>
      </div>
    </div>;
}